// extracted by mini-css-extract-plugin
export var whitetext = "footer-module--whitetext--Nomje";